<template>
  <b-carousel :id="carouselID" class="carou-slide" :class="mobile + desktop" :controls="controls">
    <b-carousel-slide :key="index" v-for="(slide, index) in slides" :class="carouselID">
      <template #img>
        <b-aspect
          :aspect="aspectRatio"
          class="d-flex align-items-center"
          :class="carouselID + index"
        >
          <img
            @click="lightboxNumber = index"
            class="d-block img-fluid"
            :src="`${publicPath}${slide.preview}`"
            alt="image slot"
          />
        </b-aspect>
      </template>
    </b-carousel-slide>
    <CoolLightBox
      :items="lightboxARR"
      :index="lightboxNumber"
      @close="lightboxNumber = null"
      :effect="'fade'"
    >
    </CoolLightBox>
  </b-carousel>
</template>

<script>
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";

export default {
  name: "CustomCarousel",
  components: {
    CoolLightBox,
  },
  props: {
    carouselID: String,
    controls: {
      type: Boolean,
      default: true,
    },
    aspectRatio: String,
    slides: Array,
    lightboxARR: Array,
    mobile: String,
    desktop: String
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      lightboxNumber: null,
    };
  },
};
</script>

<style></style>
